import { Tabs, Tab, Box, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

import { motion } from "motion/react";
import { styleTabContratos } from './Styles';
import RevisarPrestamosIndividual from './RevisarPrestamosIndividual';
import RevisarPrestamosGrupal from './RevisarPrestamosGrupal';

function AnimatedTabPanel({ children, value, index }) {
    if (value !== index) return null;

    return (
        <motion.div
            key={index}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
        >
            <Box sx={{ p: 3 }}>
                {children}
            </Box>
        </motion.div>
    );
}


const RevisarPrestamos = () => {

    const [tab, setTab] = useState(0);

    return (
        <Box sx={{ width: "100%", mt: 3 }}>

            {/* ---------- TABS ---------- */}
            <Box
                sx={{
                    borderBottom: "1px solid #ddd",
                    display: "flex",
                    justifyContent: "center"
                }}
            >
                <Tabs
                    value={tab}
                    onChange={(e, v) => setTab(v)}
                    centered
                    TabIndicatorProps={{ style: { display: "none" } }}
                    sx={styleTabContratos}
                >
                    <Tab label="Individual" />
                    <Tab label="Grupal" />
                </Tabs>
            </Box>

            {/* ---------- CONTENIDO (CON ANIMACIÓN) ---------- */}
            <AnimatedTabPanel value={tab} index={0}>
                <RevisarPrestamosIndividual />
            </AnimatedTabPanel>

            <AnimatedTabPanel value={tab} index={1}>
                <RevisarPrestamosGrupal />
            </AnimatedTabPanel>

        </Box>

    );

}

export default RevisarPrestamos